import { render, staticRenderFns } from "./AddStrategy.vue?vue&type=template&id=511f73b6&scoped=true&"
import script from "./AddStrategy.vue?vue&type=script&lang=ts&"
export * from "./AddStrategy.vue?vue&type=script&lang=ts&"
import style0 from "./AddStrategy.vue?vue&type=style&index=0&id=511f73b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511f73b6",
  null
  
)

export default component.exports